// Native implementation closeMenuOnScroll={() => true} actually disables a scroll inside of dropdown
// to prevent it the method checks whether the target is a menu
export const closeMenuOnScroll = e => {
	return !e.target.className.includes('menu');
};
